var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.currentSystem != 2 && _vm.currentSystem != 3
                ? "新增商品/券"
                : "新增商品",
            "append-to-body": "",
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            width: "850px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _vm.currentSystem != 2 && _vm.currentSystem != 3
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "券列表", name: "1" } },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          attrs: {
                            model: _vm.voucherPageParm,
                            "label-width": "80px"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "券名称：" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  placeholder: "请输入名称查询",
                                  "suffix-icon": "el-icon-search",
                                  size: "small",
                                  clearable: ""
                                },
                                on: { change: _vm.getVoucherList },
                                model: {
                                  value: _vm.voucherPageParm.couponName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.voucherPageParm,
                                      "couponName",
                                      $$v
                                    )
                                  },
                                  expression: "voucherPageParm.couponName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          ref: "multipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.voucherList,
                            "tooltip-effect": "dark",
                            height: "400"
                          },
                          on: { "selection-change": _vm.handleSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "selection",
                              width: "55",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "couName",
                              label: "券名称",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "couPrice",
                              label: "券金额",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "couEnableprice",
                              label: "满可用金额",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "couEndtime",
                              label: "有效期",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "notGetNum",
                              label: "未领次数",
                              align: "center"
                            }
                          })
                        ],
                        1
                      ),
                      _c("Pagination", {
                        attrs: {
                          childMsg: Object.assign({}, _vm.voucherPageParm, {
                            total: _vm.voucherTotal
                          }),
                          pageSizes: _vm.pageSizes
                        },
                        on: { callBack: _vm.callBack1 }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-tab-pane",
                { attrs: { label: "商品列表", name: "2" } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: {
                        model: _vm.productPageParm,
                        "label-width": "100px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称：" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入名称查询",
                              "suffix-icon": "el-icon-search",
                              size: "small",
                              clearable: ""
                            },
                            on: { change: _vm.getProductList },
                            model: {
                              value: _vm.productPageParm.productName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.productPageParm,
                                  "productName",
                                  $$v
                                )
                              },
                              expression: "productPageParm.productName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable1",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.productList,
                        "tooltip-effect": "dark",
                        height: "400"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          width: "55",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "商品名称", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [_vm._v(_vm._s(scope.row.pbasSname))]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "pbasPretium",
                          label: "商品价格",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "classOne",
                          label: "商品一级分类",
                          align: "center",
                          "show-overflow-tooltip": ""
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { label: "商品二级分类" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [_vm._v(_vm._s(scope.row.classTwo))]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "notGetNum",
                          label: "可用库存",
                          align: "center"
                        }
                      })
                    ],
                    1
                  ),
                  _c("Pagination", {
                    attrs: {
                      childMsg: Object.assign({}, _vm.productPageParm, {
                        total: _vm.productTotal
                      }),
                      pageSizes: _vm.pageSizes
                    },
                    on: { callBack: _vm.callBack2 }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right", "margin-top": "20px" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.submit }
                    },
                    [_vm._v("确认")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          _vm.dialogVisible = false
                        }
                      }
                    },
                    [_vm._v("关闭")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }